import React, { Fragment, useEffect, useRef, useState } from 'react';
import { translate } from '../../Services/translation';
import NavigationImages from './NavigationImages';
import PreHeaderLinks from './NavigationPreHeaderLinks';
import MobileTopMenu from './MobileTopMenu';
import CustomerInformation from './CustomerInformation';
import LanguageSelectorFooter from "../LanguageSelectorFooter";
import LanguageSelectorMobile from "../LanguageSelectorMobile";

const NavigationItem = ({
                            links = [],
                            contentLink = null,
                            depth = 0,
                            parentElementRef = null,
                        }) => {
    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
    };

    const [isResizing, setIsResizing] = useState(false);

    useEffect(() => {
        let resizeTimer;

        const handleResizeStart = () => {
            setIsResizing(true);
            clearTimeout(resizeTimer);

            // Set a timer to check if resizing has stopped after 200 milliseconds
            resizeTimer = setTimeout(() => {
                setIsResizing(false);
            }, 200);
        };

        // Add event listener for window resize start
        window.addEventListener('resize', handleResizeStart);

        // Clean up the event listener and timer on component unmount
        return () => {
            window.removeEventListener('resize', handleResizeStart);
            clearTimeout(resizeTimer);
        };
    }, []);

    useEffect(() => {
        if (!menuRef.current) {
            return;
        }

        if (isResizing) {
            menuRef.current.classList.add('navbar__menu--no-animation');
        } else {
            menuRef.current.classList.remove('navbar__menu--no-animation');
        }
    }, [isResizing]);

    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    const toggleExpand = () => {
        const element = elementRef.current;

        if (!element.style.height || element.style.height === '0px') {
            element.style.height =
                Array.prototype.reduce.call(
                    element.childNodes,
                    function (p, c) {
                        return p + (c.offsetHeight || 0);
                    },
                    0
                ) + 'px';
        } else {
            element.style.height = '0px';
        }

        if (parentElementRef) {
            const firstHeight = Array.prototype.reduce.call(
                parentElementRef.current.childNodes,
                function (p, c) {
                    return p + (c.offsetHeight || 0);
                },
                0
            );

            const secondHeight = Array.prototype.reduce.call(
                elementRef.current.childNodes,
                function (p, c) {
                    return p + (c.offsetHeight || 0);
                },
                0
            );

            if (isLinkListOpen) {
                parentElementRef.current.style.height =
                    firstHeight - secondHeight + 'px';
            } else {
                parentElementRef.current.style.height =
                    firstHeight + secondHeight + 'px';
            }
        }
    };

    useEffect(() => {
        const menuToggle = document.getElementById('menu-toggle');

        menuToggle.addEventListener(
            'click',
            function () {
                if (menuToggle.classList.contains('navbar__icon--close')) {
                    menuToggle.classList.remove('navbar__icon--close');
                } else {
                    menuToggle.classList.add('navbar__icon--close');
                }
            },
            false
        );
    }, []);

    const [isLinkListOpen, setIsLinkListOpen] = useState(false);

    const elementRef = useRef(null);

    function toggle() {
        setIsLinkListOpen(!isLinkListOpen);

        toggleExpand();
    }

    function expand() {
        const element = elementRef.current;

        if (!element.style.height || element.style.height === '0px') {
            element.style.height =
                Array.prototype.reduce.call(
                    element.childNodes,
                    function (p, c) {
                        return p + (c.offsetHeight || 0);
                    },
                    0
                ) + 'px';
        } else {
            element.style.height = '0px';
        }
    }

    const hoverLessClass = depth === 2 ? 'navbar__link--is-hoverless' : '';

    return (
        <Fragment>
            {!contentLink ? (
                <button
                    id="menu-toggle"
                    className="navbar__link--block navbar__link--block--menu navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    title={translate('general.menu') || 'menu'}
                    data-toggle-menu
                >
                    <svg
                        width="69"
                        height="60"
                        viewBox="0 0 69 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M19 24.5H50"
                            stroke="var(--navigation-icon-color, #FFFFFF)"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                        <path
                            d="M19 35.5H50"
                            stroke="var(--navigation-icon-color, #FFFFFF)"
                            strokeWidth="2"
                            strokeLinecap="square"
                        />
                    </svg>
                </button>
            ) : (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''} hide-desktop
                            ${hoverLessClass}`}
                        href={contentLink.url || '#'}
                    >
                        <span>{contentLink.name}</span>
                        {depth === 1 && links.length > 0 && (
                            <>
                                <div className="navbar__link-underline"></div>
                                <svg
                                    className="navbar__link-icon"
                                    width="11"
                                    height="10"
                                    viewBox="0 0 11 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g id="plus">
                                        <path
                                            id="Vector"
                                            d="M5.27539 1V9"
                                            stroke="var(--navigation-mega-menu-icon-color, var(--navigation-icon-color, #FFFFFF))"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            id="Vector_2"
                                            d="M1.27539 5H9.27539"
                                            stroke="var(--navigation-mega-menu-icon-color, var(--navigation-icon-color, #FFFFFF))"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                </svg>
                            </>
                        )}
                        {depth === 1 && links.length === 0 && (
                            <div className="hidden-mobile">
                                <div className="navbar__link-underline"></div>
                            </div>
                        )}
                    </a>
                    {contentLink.links.length > 0 && (
                        <div
                            className={`navbar__links-container navbar__links-container--depth-${depth}`}
                        >
                            <button
                                className={
                                    `navbar__link-expand-icon-button navbar__link-expand-icon-button--depth-${depth}` +
                                    (isLinkListOpen
                                        ? ' navbar__link-expand-icon-button--active'
                                        : '')
                                }
                                onClick={() => toggle()}
                            >
                                {contentLink.name}

                                <svg
                                    className={`navbar__link-expand-icon navbar__link-expand-icon--depth-${depth} ${
                                        isLinkListOpen
                                            ? ' navbar__link-expand-icon--active'
                                            : ''
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                >
                                    <path
                                        d="M8 1V15"
                                        stroke="var(--navigation-mega-menu-icon-color, var(--navigation-icon-color, #FFFFFF))"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M1 8H15"
                                        stroke="var(--navigation-mega-menu-icon-color, var(--navigation-icon-color, #FFFFFF))"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>

                            <div
                                className={
                                    'navbar__item-link-list-container' +
                                    (isLinkListOpen
                                        ? ' navbar__item-link-list-container--active'
                                        : '')
                                }
                                ref={elementRef}
                            >
                                <ul className="navbar__item-link-list">
                                    {contentLink.links.map((link, index) => {
                                        return (
                                            <li
                                                className={`navbar__item navbar__item-link-list-item navbar__item-link-list-item--depth-${depth}`}
                                                key={index}
                                            >
                                                {link.links.length > 0 ? (
                                                    <NavigationItem
                                                        depth={depth + 1}
                                                        links={link.links}
                                                        contentLink={link}
                                                        parentElementRef={
                                                            elementRef
                                                        }
                                                    />
                                                ) : (
                                                    <a
                                                        href={link.url}
                                                        className={`navbar__item-link navbar__item-link--depth-${depth}`}
                                                    >
                                                        {link.name}
                                                    </a>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className="navbar__menu" ref={menuRef}>
                    {depth === 0 && <MobileTopMenu toggleMenu={toggleMenu}/>}

                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <CustomerInformation/>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    <ul className="navbar__menu-links">
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className="navbar__item"
                                            key={index}
                                        >
                                            <NavigationItem
                                                depth={depth + 1}
                                                links={link.links}
                                                contentLink={link}
                                                onNestedLinkToggle={() =>
                                                    expand()
                                                }
                                            />
                                        </li>
                                    )
                            )}
                    </ul>

                    <PreHeaderLinks/>

                    <NavigationImages depth={depth}/>

                    {depth === 0 && <LanguageSelectorMobile/>}
                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
